import { permissionGroupDotColor, permissionGroupRingColor } from './permissionGroupColor';

// Unwired (no route enforces it - expected mid-migration, not an error) reads
// as gray-400 text + hollow ring dot + "no route" label; live is gray-800 + solid dot.

interface PermNameProps {
    permission: string;
    group: string;
    wired: boolean;
    /** Whether to render the "no route" label; off in list views to avoid repetition. */
    showState?: boolean;
    className?: string;
}

export function PermName({
    permission,
    group,
    wired,
    showState = true,
    className = ''
}: PermNameProps) {
    const dotColor = permissionGroupDotColor(group);
    const ringColor = permissionGroupRingColor(group);
    const title = wired ? permission : `${permission} - no route enforces this permission yet.`;

    return (
        <span
            title={title}
            className={`inline-flex items-center gap-1.5 min-w-0 ${className}`.trim()}
        >
            {wired ? (
                <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${dotColor}`} />
            ) : (
                <span
                    className={`h-1.5 w-1.5 rounded-full shrink-0 border bg-transparent ${ringColor}`}
                />
            )}
            <span
                className={`font-mono text-[12px] truncate ${wired ? 'text-gray-800' : 'text-gray-400'}`}
            >
                {permission}
            </span>
            {!wired && showState && (
                <span className="shrink-0 text-[9px] font-bold uppercase tracking-wider text-gray-400">
                    no route
                </span>
            )}
        </span>
    );
}
